import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

function About() {
  const [blocks, setBlocks] = useState({});
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [contentRes, settingsRes] = await Promise.all([
        axiosInstance.get("/api/content"),
        axiosInstance.get("/api/settings"),
      ]);
      const map = {};
      contentRes.data.forEach((block) => {
        map[block.block_key] = block;
      });
      setBlocks(map);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Failed to load about page data", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  const primaryColor = settings?.theme_primary_color || "#0d6efd";

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">About Us</h1>
          <p className="mb-0 opacity-75">{settings?.school_name}</p>
        </div>
      </section>

      <div className="container py-5">
        {/* About */}
        {blocks.about && (
          <section className="mb-5">
            <h2 className="fw-bold mb-3">
              <i
                className="bi bi-info-circle me-2"
                style={{ color: primaryColor }}
              ></i>
              {blocks.about.title || "About Our School"}
            </h2>
            <p
              className="text-muted"
              style={{ whiteSpace: "pre-line", lineHeight: 1.8 }}
            >
              {blocks.about.body}
            </p>
          </section>
        )}

        <div className="row g-4">
          {/* Vision */}
          {blocks.vision && (
            <div className="col-12 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "56px",
                      height: "56px",
                      backgroundColor: `${primaryColor}20`,
                    }}
                  >
                    <i
                      className="bi bi-eye fs-4"
                      style={{ color: primaryColor }}
                    ></i>
                  </div>
                  <h4 className="fw-bold">
                    {blocks.vision.title || "Our Vision"}
                  </h4>
                  <p
                    className="text-muted mb-0"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {blocks.vision.body}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Mission */}
          {blocks.mission && (
            <div className="col-12 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "56px",
                      height: "56px",
                      backgroundColor: `${primaryColor}20`,
                    }}
                  >
                    <i
                      className="bi bi-bullseye fs-4"
                      style={{ color: primaryColor }}
                    ></i>
                  </div>
                  <h4 className="fw-bold">
                    {blocks.mission.title || "Our Mission"}
                  </h4>
                  <p
                    className="text-muted mb-0"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {blocks.mission.body}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {!blocks.about && !blocks.vision && !blocks.mission && (
          <p className="text-muted text-center py-5">Content coming soon.</p>
        )}
      </div>
    </div>
  );
}

export default About;
